import moment from 'moment';

// Entra syncs about every 40 minutes and Salg notes contact at most every five, so two hours of silence means it has stopped.
export const STALE_AFTER_HOURS = 2;

export function isContactStale(lastContactAt: string | null | undefined): boolean {
  if (!lastContactAt) return false;
  return moment().diff(moment(lastContactAt), 'hours', true) > STALE_AFTER_HOURS;
}
